// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ClaimType } from "../../../data/identity/claim-type";
import { EnvelopeDocument } from "../base/envelope-document";

export class ClaimTypeDocument extends EnvelopeDocument {
	public override Item: ClaimType = new ClaimType();
}